module.exports = __webpack_public_path__ + "static/img/nx.33bee52.png";


//////////////////
// WEBPACK FOOTER
// ./static/360-panorama/images/nx.png
// module id = Cqes
// module chunks = 2